// 待办页查询条件状态管理

const state = {
  defaultQueryCondition: {
    regionIds: null,
    nameOrCode: null,
    eventType: null,
    actMonthStart: null,
    actMonthEnd: null,
    budgetTypeCode: null,
    planName: null,
    planCode: null,
    activityName: null,
    activityCode: null,
    dealerShortName: null,
    eventStartTimeBegin: null,
    eventStartTimeEnd: null,
    createUserName: null,
    oneLevelCode: null,
    twoLevelCode: null,
    threeLevelCode: null,
    custSourceCode: null
  },
  queryCondition: {
    regionIds: null,
    nameOrCode: null,
    eventType: null,
    actMonthStart: null,
    actMonthEnd: null,
    budgetTypeCode: null,
    planName: null,
    planCode: null,
    activityName: null,
    activityCode: null,
    dealerShortName: null,
    eventStartTimeBegin: null,
    eventStartTimeEnd: null,
    createUserName: null,
    oneLevelCode: null,
    twoLevelCode: null,
    threeLevelCode: null,
    custSourceCode: null
  },
  pagination: {
    current: 1,
    size: 20,
    total: 0
  },
  showFilter: false,
  sourceList: {
    custSourceList: [],
    oneSourceList: [],
    twoSourceList: [],
    threeSourceList: []
  },
  defaultSourceList: {
    custSourceList: [],
    oneSourceList: [],
    twoSourceList: [],
    threeSourceList: []
  }
}

const mutations = {
  updateQueryCondition: (state, newCondition) => {
    state.queryCondition = newCondition
  },
  resetQueryCondition(state) {
    state.queryCondition = { ...state.defaultQueryCondition }
    state.pagination = {
      current: 1,
      size: 20,
      total: 0
    }
    state.sourceList.oneSourceList = state.defaultSourceList.oneSourceList
    state.sourceList.twoSourceList = state.defaultSourceList.twoSourceList
    state.sourceList.threeSourceList = state.defaultSourceList.threeSourceList
  },
  updatePagination(state, newPagination) {
    state.pagination = newPagination
  },
  updateShowFilter(state, newState) {
    state.showFilter = newState
  },
  updateSourceList(state, newState) {
    switch (newState.level) {
      case 0:
        state.sourceList.custSourceList = newState.list
        break
      case 1:
        state.queryCondition.oneLevelCode = null
        state.queryCondition.twoLevelCode = null
        state.queryCondition.threeLevelCode = null
        state.sourceList.oneSourceList = newState.list
        break
      case 2:
        state.queryCondition.twoLevelCode = null
        state.queryCondition.threeLevelCode = null
        state.sourceList.twoSourceList = newState.list
        break
      case 3:
        state.queryCondition.threeLevelCode = null
        state.sourceList.threeSourceList = newState.list
        break
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
